"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyProfileRoute = void 0;
var react_1 = __importDefault(require("react"));
var theme_1 = require("@shapeable/theme");
var styled_components_1 = __importStar(require("styled-components"));
var use_lang_1 = require("../../../hooks/use-lang");
var use_active_person_1 = require("../../../hooks/use-active-person");
var current_path_name_1 = require("../../../utils/current-path-name");
var use_entity_definition_named_1 = require("../../../hooks/use-entity-definition-named");
var person_details_layout_1 = require("../../entities/person-details-layout");
var entity_update_button_1 = require("../../entities/entity-update-button");
var seo_1 = require("../../elements/seo");
var error_message_1 = require("../../elements/error-message");
var client_1 = require("@apollo/client");
var app_loader_1 = require("../../app/app-loader");
var person_pinned_section_1 = require("../../entities/person-pinned-section");
;
// -------- Styles -------->
var DetailsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ErrorMessageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-grow: 1;\n    width: 100%;\n  "], ["\n    flex-grow: 1;\n    width: 100%;\n  "])))
});
var UpdateButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    text-transform: uppercase;\n  "], ["\n    text-transform: uppercase;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BannerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var PinnedSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Layout: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  PinnedSection: (0, styled_components_1.default)(person_pinned_section_1.PersonPinnedSection)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), PinnedSectionStyles),
  UpdateButton: (0, styled_components_1.default)(entity_update_button_1.EntityUpdateButton)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), UpdateButtonStyles),
  Details: (0, styled_components_1.default)(person_details_layout_1.PersonDetailsLayout)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), DetailsStyles),
  ErrorMessage: (0, styled_components_1.default)(error_message_1.ErrorMessage)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ErrorMessageStyles)
};
var MyProfileRoute = function () {
  var t = (0, use_lang_1.useLang)();
  var from = (0, current_path_name_1.currentPathName)();
  var currentPerson = (0, use_active_person_1.useActivePerson)().person;
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)('Person');
  // console.log(currentPerson);
  var id = currentPerson[definition.singleIdFieldName];
  // console.log(id);
  var _a = (0, client_1.useQuery)(definition.details.query, {
      variables: {
        id: id
      }
    }),
    data = _a.data,
    loading = _a.loading;
  var person = data && data[definition.singleBySlugName];
  // console.log("ACTIVE PERSON", person);
  return react_1.default.createElement(My.Container, null, react_1.default.createElement(seo_1.Seo, {
    includeOpenGraph: true,
    title: t('Your Profile')
  }), loading ? react_1.default.createElement(app_loader_1.AppLoader, null) : person ? react_1.default.createElement(My.Layout, null, react_1.default.createElement(My.Details, {
    entity: person,
    mainFooter: react_1.default.createElement(My.PinnedSection, {
      entity: person
    })
  })) : react_1.default.createElement(My.ErrorMessage, null, react_1.default.createElement("p", null, "Sorry, we cannot find your Profile in the system."), react_1.default.createElement("p", null, "Please ", react_1.default.createElement("a", {
    href: "/logout"
  }, "logout"), " and login again using the navigation to refresh your session."), react_1.default.createElement("p", null, "If you have already done this, please ", react_1.default.createElement("a", {
    href: "mailto:".concat(process.env.SUPPORT_EMAIL, "?subject=").concat(encodeURI(process.env.SUPPORT_EMAIL_SUBJECT_PROFILE_NOT_FOUND))
  }, "contact us"), " for assistance.")));
};
exports.MyProfileRoute = MyProfileRoute;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;